import { clsx } from 'clsx';
import * as React from 'react';

import styles from './textarea.module.scss';

type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  hasError?: boolean;
};

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, hasError, ...props }, ref) => (
    <textarea
      className={clsx(styles.textarea, className, {
        [styles.hasError]: hasError,
      })}
      ref={ref}
      {...props}
    />
  )
);
Textarea.displayName = 'Textarea';

export { Textarea };
export type { TextareaProps };
